var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasterreason({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0769 16.585V18.5603L5.3231 15.8155V10.3253L7.033 11.3121C6.42563 13.6546 7.57952 15.9234 10.0769 16.585V16.585ZM16.0387 8.23518V2.74506L11.284 0V5.49012L16.0386 8.23518H16.0387ZM10.7158 5.49012V0L5.96127 2.74506V8.23518L10.7158 5.49012ZM17.2453 10.3253V15.8154L22 18.5604V13.0703L17.2453 10.3253ZM11.913 16.5862V18.5601L16.6771 15.8151V10.3251L14.9664 11.3134C15.641 13.687 14.4605 15.8637 11.913 16.5862V16.5862ZM4.75454 15.8154V10.3253L0 13.0703V18.5604L4.75449 15.8154H4.75454ZM14.0439 9.71554L15.7543 8.72751L10.9997 5.98241L6.24529 8.72738L7.95584 9.71437C9.60773 7.97122 12.2635 7.91059 14.0439 9.71549V9.71554ZM0.284109 19.0526L5.0386 21.7976L9.79327 19.0526L5.03864 16.3075L0.284109 19.0526ZM12.2067 19.0526L16.9613 21.7976L21.7158 19.0526L16.9613 16.3075L12.2067 19.0526ZM14.0731 12.5376C14.0731 10.1808 11.5041 8.69967 9.46 9.87813C7.41589 11.0566 7.41585 14.0187 9.46 15.1972C11.5041 16.3756 14.0731 14.8946 14.0731 12.5377V12.5376Z",
    fill: "#699BF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterreason);
export default __webpack_public_path__ + "static/media/masterreason.ce42dfbea42eef4668a703941b0d74ad.svg";
export { ForwardRef as ReactComponent };